import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ProgramsContent.css";
import DataAICertifications from "./DataAICertifications";

function ProgramsContent() {
  const tabLabels = [
    "SAP Ascend",
    "Cloud Elevate",
    "Data & AI",
    "Security",
    "Snowflake",
    "Agile Expert",
    "Agile Professional",
    "CDP Certification",
    ,
  ];
  const [activeTab, setActiveTab] = useState(tabLabels[0]);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const scrollTabs = (direction) => {
    const container = document.getElementById("tabsContainer");
    const tabItem = container.querySelector(".tab-item");

    if (!tabItem) return;

    const tabWidth = tabItem.offsetWidth + 10; // includes margin or gap

    if (direction === "left") {
      container.scrollLeft -= tabWidth;
    } else {
      container.scrollLeft += tabWidth;
    }
  };
  const activeIndex = tabLabels.findIndex((t) => t === activeTab);
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Programs Certifications</title>
        <h1 className="sr-only" tabIndex={0}>
          Programs & Certifications
        </h1>
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/Programs-Certifications-Mobile.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/Programs-Certifications.png"
          }
          alt="program-banner"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Programs-Certifications"
            >
              Programs & Certifications
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>Programs & Certifications</h1>
          <p>
            Elevate your capabilities with learning programs and certifications
            designed to expand your knowledge. These programs equip you with
            in-demand skills and help you move forward in your professional
            journey.
          </p>
        </div>
        {/* <p data-aos="fade-up">
          Elevate your capabilities with learning programs and certifications
          designed to expand your knowledge. These programs equip you with
          in-demand skills and help you move forward in your professional
          journey.
        </p> */}
      </div>

      {/* first section */}
      <section className="prog-certi-section" data-aos="fade-up">
        <div className="prog-certi-wrap">
          <div className="prog-certi-row">
            {/* Tabs with Arrows */}
            <div className="tabs-scroll-wrapper">
              {/* <button
                className="scroll-btn left"
                onClick={() => scrollTabs("left")}
              >
                &#8249;
              </button> */}

              <div className="tabs-container" id="tabsContainer">
                {tabLabels.map((label, index) => (
                  <div
                    key={index}
                    className={`tab-item ${
                      activeTab === label ? "active" : ""
                    } ${index === activeIndex - 1 ? "prev-active" : ""}`}
                    onClick={(e) => {
                      setActiveTab(label);
                      e.currentTarget.scrollIntoView({
                        behavior: "smooth",
                        inline: "nearest",
                        // inline: "center",
                        // block: "nearest",
                      });
                    }}
                    tabIndex={0}
                  >
                    {label}
                    {activeTab === label && <div className="tab-underline" />}
                  </div>
                ))}
              </div>

              {/* <button
                className="scroll-btn right"
                onClick={() => scrollTabs("right")}
              >
                &#8250;
              </button> */}
            </div>

            {/* Tab content */}
            <div className="track-grid">
              {activeTab === "SAP Ascend" && (
                <div className="img-zoom">
                  <a
                    href="https://atci.lkm.eitacademy.accenture.com/SAPAscend/Events"
                    target="blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/sap_ascend_new.png"
                      }
                      alt="sap-ascend"
                      className="sap-ascend-img"
                    />
                  </a>
                </div>
              )}
              {activeTab === "Cloud Elevate" && (
                <div className="img-zoom">
                  <a
                    href="https://atci.cloudelevate.accenture.com/home"
                    target="blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/cloudElevate_new.png"
                      }
                      alt="cloud-elevate"
                      className="cloud-elevate-img"
                    />
                  </a>
                </div>
              )}
              {activeTab === "Data & AI" && (
                <div className="img-zoom">
                  {/* <a
                    href="https://www.databricks.com/learn/training/certification#certifications"
                    target="blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/Data_AI_img.png"
                      }
                      alt="Data AI"
                      className="cloud-elevate-img"
                    />
                  </a> */}
                  {/* <div className="data_ai_bg_section">
                    <div>
                      <h3 className="header_section">Data & AI Certifications</h3>
                    </div>
                    <div className="databricks_box">
                      <div>
                        <div className="databricks_first_section">
                          <img src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/pg_icon1.png"
                      }
                      alt="icon" className="pg_icons"/> 
                        <h4 className="databricks_first_section_hd">Databricks Certified</h4>
                        </div>
                        <div className="databricks_content">
                          <p>Data Analyst Associate</p>
                          <p>Data Engineer Associate</p>
                          <p>Data Engineer Professional</p>
                          <p>Machine Learning Associate</p>
                          <p>Generative AI Engineer</p>
                          </div>
                      </div>
                      <div className="data_ai_second_section">
                        <div>
                      <div className="databricks_first_section">
                          <img src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/pg_icon2.png"
                      }
                      alt="icon" className="pg_icons"/> 
                        <h4 className="databricks_first_section_hd">Neo4j</h4>
                        </div>
                      <div className="neo_box">
                        <p>Certified Professional</p>
                        <p>Graph Data Science Certification </p>
                      </div>
                      </div>
                      <div>
                      <div className="databricks_first_section">
                          <img src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/pg_icon3.png"
                      }
                      alt="icon" className="pg_icons"/> 
                        <h4 className="databricks_first_section_hd">Confluent Certified</h4>
                        </div>
                      <div className="neo_box">
                        <p>Developer for Apache Kafka</p>
                        <p>Administrator for Apache Kafka</p>
                      </div>
                      </div>
                    </div>
                    <div className="data_ai_second_section">
                        <div>
                      <div className="databricks_first_section">
                          <img src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/pg_icon4.png"
                      }
                      alt="icon" className="pg_icons"/> 
                        <h4 className="databricks_first_section_hd">Talend</h4>
                        </div>
                      <div className="neo_box">
                        <p>Data Integration Certified Developer</p>
                        <p>Big Data Certified Developer</p>
                      </div>
                      </div>
                      <div>
                      <div className="databricks_first_section">
                          <img src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/pg_icon5.png"
                      }
                      alt="icon" className="pg_icons"/> 
                        <h4 className="databricks_first_section_hd">Alteryx</h4>
                        </div>
                      <div className="neo_box">
                        <p>Alteryx <br></br>Designer Core</p>
                        <p>Advanced <br></br>Certification</p>
                      </div>
                      </div>
                    </div>
                    </div>
                    </div> */}
                  <DataAICertifications />
                </div>
              )}
              {activeTab === "Security" && (
                <div className="heading-box">
                  <h2 className="main-headings_programs">Under Construction</h2>
                </div>
              )}
              {activeTab === "CDP Certification" && (
                <div className="img-zoom">
                  <a href="javascript:void(0)">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/Programs/CDP_img.png"
                      }
                      alt="CDP-Certification"
                      className="cloud-elevate-img"
                    />
                  </a>
                </div>
              )}
              {activeTab === "Snowflake" && (
                <div className="img-zoom">
                  <a
                    href="https://learn.snowflake.com/en/certifications/snowpro-core/"
                    target="blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/snowflake_updated_img.png"
                      }
                      alt="Snowflake"
                      className="cloud-elevate-img"
                    />
                  </a>
                </div>
              )}
              {activeTab === "Agile Expert" && (
                <div className="img-zoom">
                  <a
                    href="https://mycredential.accenture.com/Dashboard?certificationId=629"
                    target="blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/agile_expert_img.png"
                      }
                      alt="Snowflake"
                      className="cloud-elevate-img"
                    />
                  </a>
                </div>
              )}
              {activeTab === "Agile Professional" && (
                <div className="img-zoom">
                  <a
                    href="https://mycredential.accenture.com/Dashboard?certificationId=627"
                    target="blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Programs/Agile_professionali_updated_img.png"
                      }
                      alt="Snowflake"
                      className="cloud-elevate-img"
                    />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProgramsContent;
